import React from "react";
import ContractDashboard, { fromWei, formatDuration } from "./shared/ContractDashboard";
import tokenFunctions from "./functions/tokenFunctions";
import { nemiToken, nemiTokenAbi } from "./Contract";

const short = (v) => `${String(v).slice(0, 8)}…${String(v).slice(-6)}`;

/**
 * NEMI Token — ERC20 with permit, buy/sell against the contract and transfer limits.
 * Every function of the nemiToken contract is available through the tabs below.
 */
export default function TokenPage() {
  const overview = [
    {
      key: "myBalance",
      label: "Your NEMI Balance",
      icon: "💼",
      color: "#00ccff",
      format: (v) => `${v} NEMI`,
      compute: async ({ contract, account }) =>
        fromWei(await contract.methods.balanceOf(account).call()),
    },
    {
      key: "symbol",
      label: "Symbol",
      icon: "🏷️",
      method: "symbol",
      color: "#00ff88",
    },
    {
      key: "decimals",
      label: "Decimals",
      icon: "🔢",
      method: "decimals",
      color: "#45b7d1",
    },
    {
      key: "totalSupply",
      label: "Total Supply",
      icon: "📈",
      method: "totalSupply",
      format: (v) => `${fromWei(v)} NEMI`,
      color: "#ff00aa",
    },
    {
      key: "totalBurned",
      label: "Total Burned",
      icon: "🔥",
      method: "totalBurned",
      format: (v) => `${fromWei(v)} NEMI`,
      color: "#ff8800",
    },
    {
      key: "maxBurnAmount",
      label: "Max Burn Amount",
      icon: "🧯",
      method: "MAX_BURN_AMOUNT",
      format: (v) => `${fromWei(v)} NEMI`,
      color: "#ff6b6b",
    },
    {
      key: "maxBuyAmount",
      label: "Max Buy / Day",
      icon: "🛒",
      method: "maxBuyAmount",
      format: (v) => `${fromWei(v)} NEMI`,
      color: "#00ff88",
    },
    {
      key: "maxsSellingAmount",
      label: "Max Sell / Day",
      icon: "💱",
      method: "maxsSellingAmount",
      format: (v) => `${fromWei(v)} NEMI`,
      color: "#ffaa00",
    },
    {
      key: "maxTrPerDay",
      label: "Max Transfers / Day",
      icon: "📤",
      method: "maxTrPerDay",
      color: "#6be0d7",
    },
    {
      key: "maxMultisendPday",
      label: "Max Multisend / Day",
      icon: "📨",
      method: "maxMultisendPday",
      color: "#45b7d1",
    },
    {
      key: "locktime",
      label: "Lock Time",
      icon: "⏱️",
      method: "locktime",
      format: (v) => formatDuration(v),
      color: "#ff00aa",
    },
    {
      key: "tradeAllocation",
      label: "Trade Allocation",
      icon: "🎫",
      method: "TRADE_CONTRACT_ALLOCATION",
      format: (v) => `${fromWei(v)} NEMI`,
      color: "#00ccff",
    },
    {
      key: "liquidityAllocation",
      label: "Liquidity Allocation",
      icon: "💧",
      method: "LIQUIDITY_CONTRACT_ALLOCATION",
      format: (v) => `${fromWei(v)} NEMI`,
      color: "#6be0d7",
    },
    {
      key: "pancakePair",
      label: "Pancake Pair",
      icon: "🥞",
      method: "pancakePair",
      format: short,
      color: "#ff8800",
    },
    {
      key: "amIBlacklisted",
      label: "Your Blacklist Status",
      icon: "🚫",
      color: "#ff6b6b",
      compute: async ({ contract, account }) => {
        const blocked = await contract.methods.blacklist(account).call();
        return blocked === true || blocked === "true" ? "BLOCKED" : "Clear";
      },
    },
    {
      key: "paused",
      label: "Contract Status",
      icon: "⚡",
      method: "paused",
      format: (v) => (v === true || v === "true" ? "PAUSED" : "ACTIVE"),
      color: "#ff6b6b",
    },
  ];

  return (
    <ContractDashboard
      title="NEMI Token"
      subtitle="ERC20 with permit, contract buy/sell and per-day transfer limits"
      icon="🪙"
      accent="#00ccff"
      address={nemiToken}
      abi={nemiTokenAbi}
      functions={tokenFunctions}
      overview={overview}
      approvalTokens={[]}
    />
  );
}
